import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(theme =>
  createStyles({
    datePicker: {
      '& .MuiCalendarOrClockPicker-root': {
        boxShadow: `0px 18px 20px -8px ${STYLE.COLOR.BOX_SHADOW} !important`,
        backgroundColor: `${STYLE.COLOR.BACKGROUND_LIGHT} !important`,
        width: '328px !important',
        borderRadius: '12px',
        border: `1px solid ${STYLE.COLOR.DIVIDER}`,
        '& > div': {
          width: '328px !important',
          maxHeight: 'inherit !important',
        },
      },
      '& .PrivatePickersSlideTransition-root': {
        minHeight: '240px !important',
        paddingBottom: 12,
      },
      '& .MuiPickersPopper-paper': {
        '& .MuiCalendarPicker-root': {
          width: '328px !important',
          maxHeight: 'inherit !important',
        },
        borderRadius: '12px',
        '& .MuiDayPicker-weekDayLabel': {
          height: '40px',
          minWidth: '40px',
        },
        '& .MuiPickersDay-root': {
          height: '40px',
          width: '40px',
          borderRadius: '12px',
          backgroundColor: `${STYLE.COLOR.WHITE}`,
          border: `1px solid ${STYLE.COLOR.DIVIDER}`,
          '&.Mui-selected': {
            backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
            color: `${STYLE.COLOR.WHITE} !important`,
          },
          '&.MuiPickersDay-hiddenDaySpacingFiller': {
            border: 'none !important',
          },
        },
        '& .MuiDayPicker-weekContainer': {
          margin: '4px 0px !important',
        },
        '& .MuiDayPicker-monthContainer': {
          // position: "inherit !important",
        },
      },
    },
    leftArrowIcon: {
      transform: 'rotate(180deg)',
      '& path': {
        stroke: STYLE.COLOR.ICONS1,
      },
    },
    rightArrowIcon: {
      '& path': {
        stroke: STYLE.COLOR.ICONS1,
      },
    },
    switchViewIcon: {
      '& path': {
        stroke: STYLE.COLOR.ICONS1,
      },
    },
    switchViewIconRotated: {
      transform: 'rotate(180deg)',
      transition: 'all 0.2s ease-in',
    },
  }),
);
